import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { CliError, CliErrorCode } from '@wix/cli-error';

export const buildCommand = (services: CommandServices, cliVersion: string) =>
  createCommand('build')
    .description(
      'Invoke the astro build process, forwarding all command-line arguments.'
    )
    .allowExcessArguments(true)
    .allowUnknownOption(true)
    .passThroughOptions(true)
    .action(async (_, command) => {
      const { execa } = await import('execa');

      const { getRepoType, createPackageManager } = await import(
        '@wix/package-manager'
      );

      const { runCommand } = await import('./render-command.js');

      await runCommand(command, services, cliVersion, async (model) => {
        const repoType = await getRepoType(model.projectFolder);
        const packageManager = await createPackageManager(repoType);

        const { file, args } = packageManager.getRunBinaryCmd(
          ['astro', 'build'].concat(command.args)
        );

        try {
          const subprocess = execa(file, args, {
            cwd: model.projectFolder,
            stdin: 'inherit',
            stdout: 'inherit',
            stderr: 'pipe',
          });

          subprocess.stderr?.pipe(process.stderr);

          await subprocess;
        } catch (e: unknown) {
          throw new CliError({
            code: CliErrorCode.FailedToBuildAstroApp(),
            cause: e,
          });
        }
      });
    });
